import styled from '@emotion/styled';

export const StyledWrapper = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, max-content);
  align-items: center;
`;
